"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var lodash_1 = require("lodash");
var core_1 = require("@angular/core");
var CustomNativeDateAdapter = /** @class */ (function (_super) {
    __extends(CustomNativeDateAdapter, _super);
    function CustomNativeDateAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomNativeDateAdapter.prototype.parse = function (value) {
        var timestamp;
        if (lodash_1.isString(value) && (value.indexOf('/') > -1)) {
            var str = value.split('/');
            var year = Number(str[2]);
            var month = Number(str[1]) - 1;
            var date = Number(str[0]);
            return new Date(year, month, date);
        }
        else if (lodash_1.isString(value)) {
            timestamp = Date.parse(value);
        }
        else {
            timestamp = value;
        }
        return isNaN(timestamp) ? null : new Date(timestamp);
    };
    CustomNativeDateAdapter.prototype.format = function (date, displayFormat) {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    };
    CustomNativeDateAdapter = __decorate([
        core_1.Injectable()
    ], CustomNativeDateAdapter);
    return CustomNativeDateAdapter;
}(material_1.NativeDateAdapter));
exports.CustomNativeDateAdapter = CustomNativeDateAdapter;
//# sourceMappingURL=custom-native-date-adapter.js.map